// extracted by mini-css-extract-plugin
module.exports = {"newCode":"GenerateCodePanel_newCode__3Xb8n","spinner":"GenerateCodePanel_spinner__KCGL_"};